const PARTNER_COUNT = 6

export default function Partners() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      {/* Header */}
      <div className="text-center max-w-3xl mx-auto space-y-4 mb-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-zinc-900 leading-tight">
          Parceiros de ensino
        </h2>
        <p className="text-sm md:text-base text-zinc-900/70 leading-7">
          Igrejas e editoras que acreditam em comunidades de ensino
        </p>
      </div>

      {/* Logo cards — 3 per row on tablet, 6 on desktop */}
      <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-6 gap-4 max-w-4xl mx-auto">
        {Array.from({ length: PARTNER_COUNT }).map((_, i) => (
          <div
            key={i}
            className="bg-zinc-900 rounded-2xl shadow-sm flex items-center justify-center p-6 md:p-8 aspect-[4/3]"
          >
            <img src="/assets/partners-logo.svg" alt="Partner logo" className="h-5 w-auto" />
          </div>
        ))}
      </div>
    </section>
  )
}
